export default {
  common: {
    back: '返回',
    loading: '加载中…',
    empty: '暂无数据',
    confirm: '确认',
    cancel: '取消',
    search: '搜索',
    submit: '提交',
    retry: '重试',
    downloading: '正在下载…',
    downloadDone: '下载完成',
    browserTipLine1: '请点击右上角',
    browserTipLine2: '选择默认浏览器打开',
    workType: {
      video: '视频',
      image: '图片',
      audio: '音乐',
      pdf: 'PDF作品集',
      game: '游戏',
      bigImage: '作品集',
      linkCard: '网页作品集',
      openMaic: '可视化讲解',
      artBook: '绘本故事',
      model3d: '3D模型',
    },
    share: {
      titleVideo: '刚刷到一支很有意思的视频，立刻分享给你',
      titleImage: '发现了一张很有创意的图片，立刻分享给你',
      titleBigImage: '发现了一个超棒的原创作品集，立刻分享给你',
      titlePdf: '{title}PDF作品集',
      titleLinkCard: '{title}网页作品集',
      titleOpenMaic: '{title}',
      titleArtBook: '{title}绘本故事',
      titleAudio: '发现了一首超好听的音乐，立刻分享给你',
      titleText: '发现了一段很有想法的文字，立刻分享给你',
      titleGame: '新游戏{title}上线啦，求围观！',
      titleModel3d: '发现了一个很有创意的3D模型，立刻分享给你',
      titleDefault: '发现了超赞的创意作品合集，立刻分享给你',
      descVideo: '原创视频帧帧出片，新意拉满{suffix}',
      descImage: '原创图片太有新意，快来欣赏～',
      descBigImage: '从灵感到落地，点击探索完整创作轨迹',
      descAudio: '聆听一段全新的旋律创作～{suffix}',
      descGame: '脑洞大开的原创游戏，不玩一下你真的会后悔！',
      descOpenMaic: '我在神笔马良智绘教室生成了一份可视化讲解，快来看看吧',
      descArtBook: '超感人的原创绘本故事，快来读读看～',
      descTextEmpty: '分享了原创文字内容，快来欣赏～',
      descDefault: '这里汇聚多位同学的精彩作品，快来欣赏呀~',
      descGeneric: '超棒的原创作品，快来欣赏～',
    },
    duration: {
      seconds: '{s}秒',
      minSec: '{m}分{s}秒',
      hourMinSec: '{h}小时{m}分{s}秒',
      prefix: ' 时长：{duration}',
    },
  },
  help: {
    title: '帮助中心',
    subtitle: '神笔马良帮助中心，下面为你提供使用指南与常见问题解答。',
    welcome: 'Hi，欢迎使用',
    searchPlaceholder: '搜索相关问题',
    guessAsk: '猜你想问',
    relatedCount: '相关问题 {count} 条',
    noResult: '暂无相关问题',
    detail: { title: '问题详情' },
    list: { title: '问题列表' },
  },
  detail: {
    authorLabel: '作者：',
    noTextContent: '暂无正文',
    unknownCannotDisplay: '暂无法展示该作品',
    messageIdLabel: '消息 ID：',
    unknownRetryHint: '请稍后重试或由服务端补全资源后再打开',
    unsupportedType: '不支持的作品类型',
    typeLabel: 'type：',
    pageTitleFallback: '作品详情',
    downloadFileNameFallback: '作品',
  },
  workList: {
    loading: '加载中…',
    empty: '暂无作品',
    pageTitleDefault: '作品列表',
    multiShareTitle: '发现了超赞的创意作品合集，立刻分享给你',
    multiShareDesc: '创作合集分享，汇聚多位同学的精彩作品，快来欣赏呀～',
    authorFallback: '同学',
    unknownWorkTitle: '待补全的作品',
    unknownWorkText: '详情待服务端补全',
    errorMissingCode: '缺少作品码（code）',
    errorLoadFailed: '加载失败，请稍后重试',
    downloadFileNameFallback: '作品',
  },
  download: {
    pageHeader: '{courseName}作品下载',
    studentUnit: '人',
    worksUnit: '个作品',
    downloadButton: '作品下载',
    progressTitle: '下载进度',
    completeTitle: '下载完成',
    completeTip: '已成功下载 {success}/{total} 个文件',
    typeVideo: '视频',
    typeImage: '图片',
    typePortfolio: '作品集',
    typeEncyclopedia: '百科',
    typePictureBook: '绘本',
    typeMusic: '音乐',
    typePortfolioPdf: '作品集-PDF',
    typePortfolioWeb: '作品集-网页',
    typeGame: '游戏',
    typeAiBook: 'AI绘本',
    typeOpenMaic: '可视化讲解',
    typeVectorImage: '图片矢量图',
    typeImage2dTo3d: '图片2D转3D',
    typeUnknown: '未知',
    fileTypeModel: '模型',
    fileTypePreview: '预览图',
  },
  pdfPortfolio: {
    loading: '加载中...',
    loadError: 'PDF 加载失败，请重试',
    downloadButton: '下载 PDF',
    pageTitleFallback: 'PDF作品集',
    shareTitleFallback: 'PDF 作品集',
    shareDesc: '超棒的原创作品，快来欣赏～',
  },
  musicIsolate: {
    separating: '音轨分离中',
    originalTrack: '原曲',
    separationResult: '分离结果',
    startSeparation: '开始音轨分离',
    restartSeparation: '重新音轨分离',
  },
  modelViewer3d: {
    back: '返回',
    loading: '模型加载中…',
    loadError: '模型加载失败，请检查链接或网络',
    pageTitleFallback: '3D 模型',
    shareDesc: '超棒的原创作品，快来欣赏～',
  },
  pictureBook: {
    pageTitleFallback: '绘本详情',
    titleSuffixPortfolio: '网页作品集',
    titleSuffixBook: '绘本故事',
    shareDescPortfolio: '超棒的原创作品，快来欣赏～',
    shareDescBook: '超感人的原创绘本故事，快来读读看～',
    portfolioWorkName: '作品 {n}',
    pageName: '第 {n} 页',
  },
  lessonInfo: {
    titleArt: '人工智能AI艺术通识课程',
    titleMagic: '人工智能AI魔法绘画课程',
    titleIp: '人工智能AI超级IP课程',
    titleCourse: '人工智能AI创作课程',
    titleDesign: '人工智能AI艺术设计课程',
    titleArtDesign: '人工智能-艺科班',
    titleFallback: '课程详情',
  },
  home: {
    title: '首页',
  },
};
